
import React, { Component } from 'react';
import { 
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
} from 'reactstrap';
    
// import classNames from "classnames";
// import {
//     // chartExample1,
//     // chartExample2,
//     chartExample3,
//     chartExample4,
//   } from "variables/charts.js";

import { Line } from "react-chartjs-2";




class Dashboard extends Component {
    constructor(props) {
      super(props);
      this.state = {
        searchText:"",
      };
    }
  
    componentDidMount() {
        this.props.onLoad()
    }
  
    componentWillUnmount() {
        
    }

    getData = () =>{
        // this.props.getData()
    }
    
    getMemberByID = () =>{
      this.props.testfunction(this.state.searchText)
    }

    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    }

    extractEndDate = (input) =>{
        // Split the input string into start and end dates
        const [startDate, endDate] = input.split('-');
    
        // Extract the last two characters of the end date
        const endMonthDay = endDate.slice(4);
    
        return endMonthDay;
    }

    render() {

        let revenueData = typeof this.props.revenue!=="undefined"?this.props.revenue:[]
        let gamesFeeData = typeof this.props.games_fee!=="undefined"?this.props.games_fee:[]

        let duration_array = []
        let fee_array = []
        let event_expense_array=[]
        let aof_array = []
        let flash_array = []
        
        revenueData.forEach((revenue) => {
            duration_array.push(this.extractEndDate(revenue.duration))
            fee_array.push(revenue.fee)
            event_expense_array.push(revenue.chipRain + revenue.rgRank + revenue.cusRGRank)
        });

        gamesFeeData.forEach((game_fee) => {
            flash_array.push(game_fee.Flash_NLH)
            aof_array.push(game_fee.NLH_AoF)
        });


        
        duration_array = duration_array.reverse()
        fee_array = fee_array.reverse()
        event_expense_array = event_expense_array.reverse()
        flash_array = flash_array.reverse()
        aof_array = aof_array.reverse()



        let chart1_2_options = {
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            responsive: true,
            scales: {
              yAxes: {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.0)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  suggestedMin: 60,
                  suggestedMax: 125,
                  padding: 20,
                  fontColor: "#9a9a9a",
                },
                beginAtZero: true
              },
              xAxes: {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  padding: 20,
                  fontColor: "#9a9a9a",
                },
              },
            },
          };
          
          
          let chartExample1 = {
            data: (canvas) => {
                let ctx = canvas.getContext("2d");
            
                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
            
                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                return {
                    labels: duration_array,
                    datasets: [
                    {
                        label: "Fee",
                        fill: true,
                        backgroundColor: gradientStroke,
                        borderColor: "#1f8ef1",
                        borderWidth: 2,
                        borderDash: [],
                        borderDashOffset: 0.0,
                        pointBackgroundColor: "#1f8ef1",
                        pointBorderColor: "rgba(255,255,255,0)",
                        pointHoverBackgroundColor: "#1f8ef1",
                        pointBorderWidth: 20,
                        pointHoverRadius: 4,
                        pointHoverBorderWidth: 15,
                        pointRadius: 4,
                        data: fee_array,
                    },
                    ],
                };
                },
                
                options: chart1_2_options,
            };

            let chartExample2 = {
                data: (canvas) => {
                  let ctx = canvas.getContext("2d");
              
                  let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
              
                  gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                  gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                  gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors
              
                  return {
                    labels: duration_array,
                    datasets: [
                      {
                        label: "Flash",
                        fill: true,
                        backgroundColor: gradientStroke,
                        borderColor: "#fc9803",
                        borderWidth: 2,
                        borderDash: [],
                        borderDashOffset: 0.0,
                        pointBackgroundColor: "#fc9803",
                        pointBorderColor: "rgba(255,255,255,0)",
                        pointHoverBackgroundColor: "#fc9803",
                        pointBorderWidth: 20,
                        pointHoverRadius: 4,
                        pointHoverBorderWidth: 15,
                        pointRadius: 4,
                        data: flash_array,
                      },
                    ],
                  };
                },
                options: chart1_2_options,
              };
              
              let chartExample3 = {
                data: (canvas) => {
                  let ctx = canvas.getContext("2d");
              
                  let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
              
                  gradientStroke.addColorStop(1, "rgba(72,72,176,0.1)");
                  gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
                  gradientStroke.addColorStop(0, "rgba(119,52,169,0)"); //purple colors
              
                  return {
                    labels: duration_array,
                    datasets: [
                      {
                        label: "AOF",
                        fill: true,
                        backgroundColor: gradientStroke,
                        hoverBackgroundColor: gradientStroke,
                        borderColor: "#d048b6",
                        borderWidth: 2,
                        borderDash: [],
                        borderDashOffset: 0.0,
                        data: aof_array,
                      },
                    ],
                  };
                },
                options: {
                  maintainAspectRatio: false,
                  legend: {
                    display: false,
                  },
                  tooltips: {
                    backgroundColor: "#f5f5f5",
                    titleFontColor: "#333",
                    bodyFontColor: "#666",
                    bodySpacing: 4,
                    xPadding: 12,
                    mode: "nearest",
                    intersect: 0,
                    position: "nearest",
                  },
                  responsive: true,
                  scales: {
                    yAxes: {
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(225,78,202,0.1)",
                        zeroLineColor: "transparent",
                      },
                      ticks: {
                        suggestedMin: 60,
                        suggestedMax: 120,
                        padding: 20,
                        fontColor: "#9e9e9e",
                      },
                      beginAtZero: true
                    },
                    xAxes: {
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(225,78,202,0.1)",
                        zeroLineColor: "transparent",
                      },
                      ticks: {
                        padding: 20,
                        fontColor: "#9e9e9e",
                      },
                    },
                  },
                },
              };
              
             
              const chartExample4 = {
                data: (canvas) => {
                  let ctx = canvas.getContext("2d");
              
                  let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
              
                  gradientStroke.addColorStop(1, "rgba(66,134,121,0.15)");
                  gradientStroke.addColorStop(0.4, "rgba(66,134,121,0.0)"); //green colors
                  gradientStroke.addColorStop(0, "rgba(66,134,121,0)"); //green colors
              
                  return {
                    labels: duration_array,
                    datasets: [
                      {
                        label: "活動支出",
                        fill: true,
                        backgroundColor: gradientStroke,
                        borderColor: "#00d6b4",
                        borderWidth: 2,
                        borderDash: [],
                        borderDashOffset: 0.0,
                        pointBackgroundColor: "#00d6b4",
                        pointBorderColor: "rgba(255,255,255,0)",
                        pointHoverBackgroundColor: "#00d6b4",
                        pointBorderWidth: 20,
                        pointHoverRadius: 4,
                        pointHoverBorderWidth: 15,
                        pointRadius: 4,
                        data: event_expense_array,
                      },
                    ],
                  };
                },
                options: {
                  maintainAspectRatio: false,
                  legend: {
                    display: false,
                  },
              
                  tooltips: {
                    backgroundColor: "#f5f5f5",
                    titleFontColor: "#333",
                    bodyFontColor: "#666",
                    bodySpacing: 4,
                    xPadding: 12,
                    mode: "nearest",
                    intersect: 0,
                    position: "nearest",
                  },
                  responsive: true,
                  scales: {
                    yAxes: {
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(29,140,248,0.0)",
                        zeroLineColor: "transparent",
                      },
                      ticks: {
                        suggestedMin: 50,
                        suggestedMax: 125,
                        padding: 20,
                        fontColor: "#9e9e9e",
                      },
                    },
                    xAxes: {
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(0,242,195,0.1)",
                        zeroLineColor: "transparent",
                      },
                      ticks: {
                        padding: 20,
                        fontColor: "#9e9e9e",
                      },
                    },
                  },
                },
              };

        return <div className="content">
            {/* <Row>
                <Col>
                <label>Search Members</label>
                      <InputGroup>
                        <Input
                          defaultValue=""
                          placeholder="Enter search options"
                          type="text"
                          name = "searchText"
                          value = {this.state.searchText}
                          onChange={this.handleChange.bind(this)}
                        />
                        <Button onClick={()=>{this.getMemberByID()}}>
                            search
                        </Button>
                      </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                    <CardHeader>
                        <CardTitle tag="h4">Simple Table</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <Table className="tablesorter" responsive>
                        <thead className="text-primary">
                            <tr>
                            <th>Member ID</th>
                            <th>Member Name</th>
                            <th>Club Name</th>
                            <th>Club ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(typeof this.props.members !== "undefined")&&
                                this.props.members.map((member, index) => (
                                <tr>
                                    <td>{member.Member.ID}</td>
                                    <td>{member.Member.Nickname}</td>
                                    <td>{member.Club_ID}</td>
                                    <td>{member.Club_Name}</td>
                                </tr>
                            ))}
                        </tbody>
                        </Table>
                    </CardBody>
                    </Card>
                </Col>
            </Row> */}
            <Row>
                <Col md="6">
                <Card className="card-chart">
                    <CardHeader>
                        <Row>
                        <Col className="text-left" sm="6">
                            <h5 className="card-category">Total Fee</h5>
                            <CardTitle tag="h2">總服務費</CardTitle>
                        </Col>
                        <Col sm="6">
                        
                        </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <div className="chart-area">
                        <Line
                            data={chartExample1['data']}
                            options={chartExample1.options}
                        />
                        </div>
                    </CardBody>
                    </Card>
                </Col>
                <Col md="6">
                    <Card className="card-chart">
                    <CardHeader>
                        <h5 className="card-category">FLASH_NLH</h5>
                        <CardTitle tag="h3">
                        FLASH_NLH水量
                        </CardTitle>
                    </CardHeader>
                    <CardBody>
                        <div className="chart-area">
                        <Line
                            data={chartExample2['data']}
                            options={chartExample2.options}
                        />
                        </div>
                    </CardBody>
                    </Card>
                </Col>
            </Row>
            
            <Row>
              <Col md="6">
                  <Card className="card-chart">
                  <CardHeader>
                      <h5 className="card-category">NLH_AOF</h5>
                      <CardTitle tag="h3">
                      NLH_AOF水量
                      </CardTitle>
                  </CardHeader>
                  <CardBody>
                      <div className="chart-area">
                      <Line
                          data={chartExample3['data']}
                          options={chartExample3.options}
                      />
                      </div>
                  </CardBody>
                  </Card>
              </Col>
              <Col md="6">
                  <Card className="card-chart">
                  <CardHeader>
                      <h5 className="card-category">Event Expenses</h5>
                      <CardTitle tag="h3">
                      {/* <i className="tim-icons icon-send text-success" /> 12,100K */}
                      活動支出
                      </CardTitle>
                  </CardHeader>
                  <CardBody>
                      <div className="chart-area">
                      <Line
                          data={chartExample4['data']}
                          options={chartExample4.options}
                      />
                      </div>
                  </CardBody>
                  </Card>
              </Col>
            </Row>
            
            
        </div>
    }
}

export default Dashboard;